import React, { Component, createRef } from 'react';
import GeckoRequest from 'services/gecko-request';
import GeckoLocation from 'services/gecko-location';
import { GeckoToastService, GeckoModalService, Overlay, Tooltip } from 'ui';
import NumberRing from 'components/NumberRing';
import StateRing from 'components/StateRing';
import PracticeModal from '.././PracticeModal';
import moment from 'moment';
import { connect } from 'react-redux';
import { renderError } from 'services/gecko-error';

import './index.scss';

class ActiveBotBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numCurrentlyTraining: 0,
      progress: null,
      fetchedMisses: true,
      show: false,
    };
    this.target = createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.bot &&
      this.props.bot !== prevProps.bot &&
      this.state.fetchedMisses
    ) {
      this.setState({ fetchedMisses: false });
      this.fetchMisses(this.props.bot.id);
    }
    if (
      this.props.bot &&
      prevProps.bot &&
      prevProps.bot.unsynced_responses.length > 0 &&
      this.props.bot.unsynced_responses.length === 0 &&
      this.props.bot.unsynced_responses.length !==
        prevProps.bot.unsynced_responses.length
    ) {
      const currentlyTraining =
        prevProps.bot.training_status === 'trained'
          ? 0
          : this.state.numCurrentlyTraining;
      this.setState({
        numCurrentlyTraining:
          prevProps.bot.unsynced_responses.length + currentlyTraining,
      });
    }
  }

  fetchMisses(botId) {
    return GeckoRequest.get(`/bots/${botId}/misses`)
      .then((payload) => {
        this.setState({ misses: payload.total, fetchedMisses: true });
      })
      .catch((err) => {
        this.setState({ fetchedMisses: true });
      });
  }

  trainingBot() {
    GeckoRequest.post(`/bots/${this.props.botId}/trainings/start`)
      .then(() => {
        new GeckoToastService().success('Training started');
        GeckoRequest.get(`/bots/${this.props.botId}/trainings`).then(
          (trainings) => {
            this.setState({ trainings });
            GeckoLocation.reload();
          }
        );
      })
      .catch(renderError);
  }

  startTraining() {
    if (
      this.props.bot.unsynced_responses &&
      this.props.bot.unsynced_responses.length
    ) {
      this.trainingBot();
    } else if (
      this.props.bot.training_status === 'training' &&
      !this.props.bot.unsynced_responses.length
    ) {
      new GeckoToastService().warning('Training already in progress');
    } else if (this.props.bot.training_status === 'trained') {
      new GeckoToastService().success('Training not required');
    } else this.trainingBot();
  }

  openPracticeMode() {
    return new GeckoModalService().open(
      () => {
        return <PracticeModal botId={this.props.botId} />;
      },
      { backdrop: 'static' }
    );
  }

  handleOpportunitiesClick() {
    GeckoLocation.goTo(`/bots/${this.props.botId}/train`);
  }

  answerPlurality(isPlural) {
    if (isPlural) return 'answer';
    return 'answers';
  }

  getBotStatus() {
    if (
      !this.props.bot ||
      (this.props.bot.unsynced_responses.length &&
        this.props.bot.training_status !== 'training')
    )
      return 'needs_trained';
    return this.props.bot.training_status;
  }

  getStatusMessage() {
    if (!this.props.bot) return 'Bot will require training.';
    if (this.props.bot.unsynced_responses.length)
      return `Training required for ${
        this.props.bot.unsynced_responses.length
      } new ${this.answerPlurality(
        this.props.bot.unsynced_responses.length === 1
      )}.`;
    if (this.props.bot.training_status === 'training')
      return `Currently training on ${
        this.state.numCurrentlyTraining >= 1
          ? this.state.numCurrentlyTraining
          : ''
      } new ${this.answerPlurality(this.state.numCurrentlyTraining === 1)}.`;
    if (this.props.bot.last_trained)
      return `Last trained: ${moment(this.props.bot.last_trained).fromNow()}.`;
    return 'Bot requires training.';
  }

  render() {
    // renders bot fields as blank until active bot found
    const loadClass = this.props.bot ? 'load' : '';
    const newClass = this.props.botId === 'new' ? 'new' : '';

    const ringStates = {
      trained: {
        tooltip: 'Fully trained',
        preset: 'success',
        icon: 'fas fa-check',
      },
      training: {
        tooltip:
          this.props.bot && this.props.bot.unsynced_responses.length
            ? 'Click to retrain bot'
            : 'Training in progress',
        preset:
          this.props.bot && this.props.bot.unsynced_responses.length
            ? 'warning'
            : 'info',
        icon: 'fa-spin far fa-cog',
      },
      failed: {
        tooltip: 'Training failed',
        preset: 'danger',
        icon: 'fas fa-exclamation',
      },
      needs_trained: {
        tooltip: 'Click to retrain bot',
        preset: 'warning',
        icon: 'fas fa-exclamation',
      },
    };

    const botStatus = this.getBotStatus();
    const botStatusMessage = this.getStatusMessage();

    return (
      <div className={newClass}>
        <div className={`row bot-body-container ${loadClass}`}>
          <div className="col-6 border-right">
            <p className="status-title">Training Status</p>
            <div
              className="circle-body"
              id="progress"
              onClick={this.startTraining.bind(this)}
            >
              <StateRing
                states={ringStates}
                radius={30}
                stroke={3}
                defaultState="failed"
                state={botStatus}
              />
            </div>
            <p className="status-sub-title">{botStatusMessage}</p>
          </div>
          <div className="col-6">
            <p className="status-title">Opportunities</p>
            <div
              className="circle-body"
              id="opportunities"
              onClick={() => {
                this.handleOpportunitiesClick();
              }}
              ref={this.target}
              onMouseEnter={() => this.setState({ show: true })}
              onMouseLeave={() => this.setState({ show: false })}
            >
              <NumberRing
                radius="30"
                stroke="3"
                highBreakpoint="100"
                lowBreakpoint="50"
                number={this.props.misses}
              />
              <Overlay
                target={this.target.current}
                show={this.state.show}
                placement="bottom"
              >
                {(props) => <Tooltip {...props}>View missed messages</Tooltip>}
              </Overlay>
            </div>
            <p className="status-sub-title">
              {this.props.misses > 0
                ? `You have ${this.props.misses} training ${
                    this.props.misses === 1 ? 'opportunity' : 'opportunities'
                  } to complete`
                : 'You have no new training opportunities. Good job!'}
            </p>
          </div>
        </div>

        <div className={`bot-footer-container ${loadClass}`}>
          <div className="train-title" onClick={this.startTraining.bind(this)}>
            <i className="far fa-comment-alt-check"></i> Retrain Bot
          </div>
          <div
            className="train-title"
            onClick={this.openPracticeMode.bind(this)}
          >
            <i className="far fa-robot"></i> Start Practice Bot
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store, props) => {
  return {
    misses: store.botsRoute.misses.total,
  };
};

export default connect(mapStateToProps)(ActiveBotBody);
